module.exports = __webpack_public_path__ + "img/square-arrow-down.b25ef044.svg";